import { callApi } from './ApiClient';

const getExecutiveList = (data, dispatch) => {
  return callApi('GET', `/executive_list`, data, dispatch);
}

const getExecutiveListById = (id, data, dispatch) => {
  return callApi('GET', `/executive_list/${id}`, data, dispatch);
}

const getExecutiveListByExecutivePersonId = (executive_person_id, data, dispatch) => {
  return callApi('GET', `/executive_list/executive_persons/${executive_person_id}`, data, dispatch);
}

const postSendExecutiveList = (data, dispatch) => {
  return callApi('POST', `/executive_list/send_history`, data, dispatch);
}

// コピペ検知ログ（ログインメールアドレス・日時等）をバックエンドに記録する
const postExecutiveListCopyLog = (data, dispatch) => {
  return callApi('POST', `/executive_list/copy_log`, data, dispatch);
}

const postExecutiveListSearch = (data, dispatch) => {
  return callApi('POST', `/executive_list/search`, data, dispatch);
}

const postNoMatchCorporationCsv = (data, dispatch) => {
  return callApi('POST', `/executive_list/no_match_corporation_csv`, data, dispatch);
}

const getExportedList = (data, dispatch) => {
  return callApi('POST', `/executive_list/get_exported_list`, data, dispatch);
}

const postExecutiveListCsv = (data, dispatch) => {
  return callApi('POST', `/executive_list/csv`, data, dispatch);
}

const postExecutiveListGetTags = (data, dispatch) => {
  return callApi('POST', `/executive_list/tags/getTags`, data, dispatch);
}

const postExecutiveListDeleteTags = (data, dispatch) => {
  return callApi('POST', `/executive_list/tags/deleteMulti`, data, dispatch);
}

const postExecutiveListUpdateTagName = (data, dispatch) => {
  return callApi('POST', `/executive_list/tags/updateTagNameMulti`, data, dispatch);
}

const postExecutiveListUpdateTag = (data, dispatch) => {
  return callApi('POST', `/executive_list/tags/updateMulti`, data, dispatch);
}

const postExecutiveListSalesforceSync = (data, dispatch) => {
  return callApi('POST', `/executive_list/salesforce/sync`, data, dispatch);
}

const postExecutiveListSearchAi = (data, dispatch) => {
  return callApi('POST', `/executive_list/search/ai`, data, dispatch);
}

// 自然文から検索条件(conditions)を生成するAI API
const postExecutiveListBuildConditionsAi = (data, dispatch) => {
  return callApi('POST', `/executive_list/build_conditions/ai`, data, dispatch);
}

// Web発見候補(取り込み中)のキーマンを取得するAPI（corporate_numberをキーにポーリング）
const getWebCandidateKeymen = (data, dispatch) => {
  return callApi('GET', `/executive_list/web_candidate/keymen`, data, dispatch);
}

// AIレコメンドのWeb補完結果を取得するAPI（web_job_tokenをキーに ready までポーリング）
const getAiWebResult = (data, dispatch) => {
  return callApi('GET', `/executive_list/ai/web_result`, data, dispatch);
}

// 2段階API: Step 1 - URL解析のみ
const postAttackListAnalyzeUrl = (data, dispatch) => {
  return callApi('POST', `/executive_list/analyze_url`, data, dispatch);
}

// 2段階API: Step 2 - タグ付け実行
const postAttackListExecuteTagging = (data, dispatch) => {
  return callApi('POST', `/executive_list/execute_tagging`, data, dispatch);
}

export const ExecutiveListApi = {
  postSendExecutiveList,
  postExecutiveListCopyLog,
  getExecutiveList,
  getExecutiveListById,
  getExecutiveListByExecutivePersonId,
  getExportedList,
  postExecutiveListSearch,
  postNoMatchCorporationCsv,
  postExecutiveListCsv,
  postExecutiveListGetTags,
  postExecutiveListDeleteTags,
  postExecutiveListUpdateTagName,
  postExecutiveListUpdateTag,
  postExecutiveListSalesforceSync,
  postExecutiveListSearchAi,
  postExecutiveListBuildConditionsAi,
  getWebCandidateKeymen,
  getAiWebResult,
  postAttackListAnalyzeUrl,
  postAttackListExecuteTagging,
};



// WEBPACK FOOTER //
// ./src/redux/api/ExecutiveListApi.js